// extracted by mini-css-extract-plugin
export default {"fab":"Control_fab__to75Q"};